<template>
	<transition
			name="custom-classes-transition"
			:enter-active-class="$_pc_styleComponentAnimation()">
		<template v-if="$_pc_stateComponentIsInitialized">
			<v-row no-gutters>
				<v-col>
					<template v-if="!isFalse(text)">
						<v-row justify="center">
							<v-col cols="10 center">
								<span class="caption" v-text="text" />
							</v-col>
						</v-row>
					</template>
					<v-row no-gutters justify="center">
						<v-col cols="auto">
							<v-progress-circular 
									:color="$_pc_styleProgressCircularColor"
									:indeterminate="$_pc_styleProgressCircularIndeterminate"
									:size="$_pc_styleProgressCircularSize"
									:value="$_pc_styleProgressCircularValue"
									:width="$_pc_styleProgressCircularWidth" />
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</template>
		<template v-else>
			<v-progress-circular size="24" width="3" indeterminate />
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'ProgressCircular',
		props: {
			text: String
		},
		data() {
			return {
				componentName_: 'progressCircular'
			}
		},
		computed: {
			// state
			$_pc_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_pc_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_pc_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_pc_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_pc_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_pc_inits(), 'component')
				}
			},
			$_pc_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_pc_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_pc_styleProgressCircular() {
				const self_ = this;
				if(self_.isEmpty(self_.$_pc_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_pc_inits(), 'progressCircular')
			},
			$_pc_styleProgressCircularColor() {
				const self_ = this;
				const progress_ = self_.$_pc_styleProgressCircular;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.color)
			},
			$_pc_styleProgressCircularIndeterminate() {
				const self_ = this;
				const progress_ = self_.$_pc_styleProgressCircular;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.indeterminate)
			},
			$_pc_styleProgressCircularSize() {
				const self_ = this;
				const progress_ = self_.$_pc_styleProgressCircular;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.size)
			},
			$_pc_styleProgressCircularValue() {
				const self_ = this;
				const progress_ = self_.$_pc_styleProgressCircular;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.value)
			},
			$_pc_styleProgressCircularWidth() {
				const self_ = this;
				const progress_ = self_.$_pc_styleProgressCircular;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.width)
			}
		}
	}
</script>